import {
    ErrorLayout,
    LoadingAnimation,
    SidebarNavigationProvider,
    type SidebarNavigationLinkConfig,
} from '@uag/react-core';
import { useGetCurrentContributor } from '@uag/welcome-shared/src/api/queries/contributors/contributors';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-modal-promise';
import { Outlet } from 'react-router';

import { CurrentContributorProvider } from './CurrentContributorProvider';

export const Frame = () => {
    const { isLoading, data: currentContributor } = useGetCurrentContributor();
    const { t } = useTranslation();

    if (isLoading) {
        return <LoadingAnimation />;
    }

    if (!currentContributor) {
        return <ErrorLayout description={t('errorLoadingCurrentContributor')} />;
    }

    const navLinks: SidebarNavigationLinkConfig[] = [
        {
            label: t('requests'),
            link: '/requests',
            icon: 'inbox' as const,
        },
        ...(currentContributor.data.isCompanySupport
            ? [
                  {
                      label: t('temporaryAccess'),
                      link: '/temporary-access',
                      icon: 'key' as const,
                  },
              ]
            : []),
        {
            label: t('responsibleTeam'),
            link: '/teams',
            icon: 'group' as const,
        },
    ];

    return (
        <CurrentContributorProvider currentContributor={currentContributor.data}>
            <SidebarNavigationProvider navLinks={navLinks}>
                <Container />
                <Outlet />
            </SidebarNavigationProvider>
        </CurrentContributorProvider>
    );
};
